import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

import AddAppointmentLayer from "../components/AddAppointmentLayer";
import AddStockLayer from "../components/AddStockLayer";
import EditStockLayer from "../components/EditStockLayer";


const EditStockPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Add Stock" />

        {/* AddUserLayer */}
        <EditStockLayer />


      </MasterLayout>
    </>
  );
};

export default EditStockPage;
